import React from "react";
import {
  MdHome,
  MdSettings,
  MdPerson,
  MdMail,
  MdFolder,
  MdDescription,
  MdPrint,
  MdSearch,
  MdClose,
  MdEvent,
  MdAssignment,
  MdAttachFile,
  MdDelete,
  MdSave,
  MdExitToApp,
  MdEdit,
  MdCheckCircle,
  MdReceipt,
  MdBuild,
  MdInventory,
  MdLocalShipping,
  MdShoppingCart,
  MdPlayCircleFilled,
  MdPauseCircleFilled,
  MdStopCircle,
  MdSettingsApplications,
  MdColorLens,
  MdSpeed,
  MdAssessment,
  MdMemory,
  MdLogout,
   MdViewList,
   MdAdd, MdAddCircle, MdAddBox,
   MdError, MdInfo,
   MdVisibility,
   MdVisibilityOff,
   MdKeyboardCapslock,
   MdChevronLeft,
   MdChevronRight,
    MdFilterAlt,
    MdSchema, // <--- Icono a añadir si es posible
} from "react-icons/md";

import {
  FaFileAlt,
  FaFileInvoiceDollar,
  FaClipboardList,
  FaBoxOpen,
  FaTruck,
  FaShoppingBasket,
  FaUsers,
  FaClock,
  FaTrashAlt,
  FaSignOutAlt,
  FaEdit,
  FaCheck,
  FaUserTie,
  FaPlay,
  FaPause,
  FaStop,
  FaFileSignature,
  FaCogs,
  FaIndustry,
  FaTools,
  FaPalette,
  FaChartBar,
  FaTachometerAlt,
  FaLaptopCode,
  FaHardHat,
  FaFileExcel, FaFileWord, FaFilePdf,
  FaCircle, FaSquare ,
  FaDatabase ,
   FaHandshake,        // cliente habitual
  FaRegLightbulb,     // cliente potencial
  FaUserClock,        // cliente de visita
  FaUserSlash,         // cliente anulado
  FaCoffee, FaHamburger
  
} from "react-icons/fa";




const icons = {
  1: { component: MdHome, description: "Página principal, inicio", caption: "Inicio" },
  2: { component: MdSettings, description: "Configuración general", caption: "Config" },
  3: { component: MdClose, description: "Close", caption: "Cerrar" },
  4: { component: MdPerson, description: "Usuario, perfil", caption: "Perfil" },
  5: { component: MdMail, description: "Correo electrónico, mensajes", caption: "Correo" },
  6: { component: MdFolder, description: "Carpetas, archivos", caption: "Carpetas" },
  7: { component: MdDescription, description: "Documentos, textos generales", caption: "Docs" },
  8: { component: MdPrint, description: "Impresión", caption: "Imprimir" },
  9: { component: MdSearch, description: "Búsqueda", caption: "Buscar" },
  10: { component: MdAssignment, description: "Tareas, asignaciones", caption: "Tareas" },
  11: { component: MdAttachFile, description: "Adjuntar archivos", caption: "Adjuntar" },
  12: { component: MdDelete, description: "Eliminar, borrar", caption: "Borrar" },
  13: { component: MdSave, description: "Guardar", caption: "Guardar" },
  14: { component: MdExitToApp, description: "Salir, cerrar sesión", caption: "Salir" },
  15: { component: MdEdit, description: "Editar, modificar", caption: "Editar" },
  16: { component: MdCheckCircle, description: "Confirmar, aprobado", caption: "OK" },
  17: { component: FaFileAlt, description: "Documento estándar", caption: "Doc" },
  18: { component: FaFileInvoiceDollar, description: "Facturas, documentos de cobro", caption: "Factura" },
  19: { component: FaClipboardList, description: "Listas, checklist", caption: "Lista" },
  20: { component: FaBoxOpen, description: "Paquetes, stock, inventario", caption: "Stock" },
  21: { component: MdReceipt, description: "Recibos, tickets", caption: "Recibo" },
  22: { component: MdBuild, description: "Construcción, configuración", caption: "Herram." },
  23: { component: MdInventory, description: "Inventario", caption: "Inventario" },
  24: { component: MdLocalShipping, description: "Envíos, logística", caption: "Envío" },
  25: { component: FaTruck, description: "Transporte, flota de vehículos", caption: "Camión" },
  26: { component: MdShoppingCart, description: "Carrito de compras", caption: "Carrito" },
  27: { component: FaShoppingBasket, description: "Cesta de compra", caption: "Cesta" },
  28: { component: FaUsers, description: "Usuarios, grupo", caption: "Usuarios" },
  29: { component: FaClock, description: "Tiempo, reloj", caption: "Hora" },
  30: { component: FaTrashAlt, description: "Papelera, eliminar", caption: "Papelera" },
  31: { component: MdLogout, description: "Cerrar sesión", caption: "Salir" },
  32: { component: FaEdit, description: "Editar (alternativo)", caption: "Editar" },
  33: { component: FaCheck, description: "Confirmar (alternativo)", caption: "OK" },
  34: { component: FaUserTie, description: "Usuario profesional, ejecutivo", caption: "Ejecutivo" },
  35: { component: MdPlayCircleFilled, description: "Activar producción (play)", caption: "Play" },
  36: { component: MdPauseCircleFilled, description: "Pausar producción", caption: "Pausa" },
  37: { component: MdStopCircle, description: "Parar producción", caption: "Parar" },
  38: { component: FaPlay, description: "Activar producción (alternativo)", caption: "Play" },
  39: { component: FaPause, description: "Pausar producción (alternativo)", caption: "Pausa" },
  40: { component: FaStop, description: "Parar producción (alternativo)", caption: "Parar" },
  41: { component: FaFileSignature, description: "Documentación firmada, autorizaciones", caption: "Firma" },
  42: { component: MdSettingsApplications, description: "Configuración avanzada máquinas", caption: "Avanzado" },
  43: { component: FaCogs, description: "Configuración y maquinaria", caption: "Máquinas" },
  44: { component: FaIndustry, description: "Industria, fábrica", caption: "Industria" },
  45: { component: FaTools, description: "Herramientas, mantenimiento", caption: "Herram." },
  46: { component: MdColorLens, description: "Colorimetría, control de color", caption: "Color" },
  47: { component: FaPalette, description: "Preimpresión, paleta de colores", caption: "Paleta" },
  48: { component: MdSpeed, description: "Velocidad, control de proceso", caption: "Velocidad" },
  49: { component: FaChartBar, description: "Estadísticas, medición", caption: "Stats" },
  50: { component: MdAssessment, description: "Reportes, análisis", caption: "Reporte" },
  51: { component: FaTachometerAlt, description: "Medir rendimiento, panel de control", caption: "Rendim." },
  52: { component: MdMemory, description: "Memoria, gestión de datos de máquinas", caption: "Memoria" },
  53: { component: FaLaptopCode, description: "Software, preimpresión", caption: "Software" },
  54: { component: FaHardHat, description: "Seguridad industrial, equipo de protección", caption: "Seguridad" },
  55: { component: FaFileExcel, description: "Documento de Excel, hoja de cálculo", caption: "Excel" },
56: { component: FaFileWord, description: "Documento de Word, texto", caption: "Word" },
57: { component: FaFilePdf, description: "Documento en formato PDF", caption: "PDF" },
58: { component: () => <FaCircle color="#ff0000" />, description: "Círculo rojo fuerte", caption: "Rojo fuerte" },
59: { component: () => <FaCircle color="#00cc00" />, description: "Círculo verde fuerte", caption: "Verde fuerte" },
60: { component: () => <FaCircle color="#ffcc00" />, description: "Círculo amarillo fuerte", caption: "Amarillo fuerte" },
61: { component: () => <FaCircle color="#0066ff" />, description: "Círculo azul fuerte", caption: "Azul fuerte" },
62: { component: () => <FaCircle color="#666666" />, description: "Círculo gris fuerte", caption: "Gris fuerte" },
63: { component: () => <FaCircle color="#ffffff" />, description: "Círculo blanco", caption: "Blanco" },
64: { component: () => <FaCircle color="#990000" />, description: "Círculo rojo oscuro", caption: "Rojo oscuro" },
65: { component: () => <FaCircle color="#006600" />, description: "Círculo verde oscuro", caption: "Verde oscuro" },
66: { component: () => <FaCircle color="#cc9900" />, description: "Círculo amarillo oscuro", caption: "Amarillo oscuro" },
67: { component: () => <FaCircle color="#003366" />, description: "Círculo azul oscuro", caption: "Azul oscuro" },
68: { component: () => <FaCircle color="#333333" />, description: "Círculo gris oscuro", caption: "Gris oscuro" },
69: { component: () => <FaCircle color="#000000" />, description: "Círculo negro", caption: "Negro" },
70: { component: () => <FaSquare color="#ff0000" />, description: "Cuadrado rojo fuerte", caption: "Rojo fuerte" },
71: { component: () => <FaSquare color="#00cc00" />, description: "Cuadrado verde fuerte", caption: "Verde fuerte" },
72: { component: () => <FaSquare color="#ffcc00" />, description: "Cuadrado amarillo fuerte", caption: "Amarillo fuerte" },
73: { component: () => <FaSquare color="#0066ff" />, description: "Cuadrado azul fuerte", caption: "Azul fuerte" },
74: { component: () => <FaSquare color="#666666" />, description: "Cuadrado gris fuerte", caption: "Gris fuerte" },
75: { component: () => <FaSquare color="#ffffff" />, description: "Cuadrado blanco", caption: "Blanco" },
76: { component: () => <FaSquare color="#990000" />, description: "Cuadrado rojo oscuro", caption: "Rojo oscuro" },
77: { component: () => <FaSquare color="#006600" />, description: "Cuadrado verde oscuro", caption: "Verde oscuro" },
78: { component: () => <FaSquare color="#cc9900" />, description: "Cuadrado amarillo oscuro", caption: "Amarillo oscuro" },
79: { component: () => <FaSquare color="#003366" />, description: "Cuadrado azul oscuro", caption: "Azul oscuro" },
80: { component: () => <FaSquare color="#333333" />, description: "Cuadrado gris oscuro", caption: "Gris oscuro" },
81: { component: () => <FaSquare color="#000000" />, description: "Cuadrado negro", caption: "Negro" },
82: { component: FaDatabase, description: "Base de datos, consultas SQL, edición SQL", caption: "SQL" },
83: { component: MdViewList, description: "Visualizar listados, vista en lista", caption: "Listados" },
84: { component: FaHandshake, description: "Cliente habitual", caption: "Hab." },
85: { component: FaRegLightbulb, description: "Cliente potencial", caption: "Potencial" },
86: { component: FaUserClock, description: "Cliente de visita", caption: "Visita" },
87: { component: FaUserSlash, description: "Cliente anulado", caption: "Anulado" },
88: { component: FaCogs, description: "Función definida por el usuario", caption: "Función" },
89: { component: FaTools, description: "Procedimiento almacenado o procedimiento general", caption: "Proced." },
90: { component: FaDatabase, description: "Código SQL, consulta SQL", caption: "SQL" },
91: { component: FaLaptopCode, description: "Código JavaScript, lógica frontend", caption: "JS" },
92: { component: MdViewList, description: "Vista o visualización de datos", caption: "Vista" },
93: { component: MdEvent, description: "Evento asociado, programación reactiva", caption: "Evento" },
94: { component: FaClipboardList, description: "Método o rutina específica", caption: "Método" },
95: { component: MdAdd, description: "Añadir, agregar, nuevo", caption: "Añadir" },
96: { component: MdAddCircle, description: "Añadir con énfasis (círculo)", caption: "Añadir +" },
97: { component: MdAddBox, description: "Añadir en caja, formularios", caption: "Nuevo" },
 98: { component: MdChevronLeft, description: "Colapsar menú lateral", caption: "Colapsar" },
  99: { component: MdChevronRight, description: "Expandir menú lateral", caption: "Expandir" },

100: { component: MdError, description: "Mensaje de error", caption: "Error" },
101: { component: MdInfo, description: "Mensaje informativo", caption: "Info" },
102: { component: MdVisibility, description: "Mostrar contraseña", caption: "Ver" },
103: { component: MdVisibilityOff, description: "Ocultar contraseña", caption: "Ocultar" },
104: { component: MdKeyboardCapslock, description: "Mayúsculas activadas", caption: "CapsLock" },
105: { component: MdChevronLeft, description: "Volver a la pantalla anterior", caption: "Back" },
106: { component: MdChevronRight, description: "Volver a la pantalla siguiente", caption: "Next" },
107: { component: MdFilterAlt, description: "Filtro aplicado, selección activa en filtros o matchcode", caption: "Filtro" },
108: { component: MdSchema,  description: "Ruta de máquinas de producción por defecto", caption: "Ruta Default" },
109: { component: FaCoffee, description: "Pausa café", caption: "Café" },
110: { component: FaHamburger, description: "Pausa bocadillo", caption: "Bocadillo" },
};

// Componente Icono adaptado a Tailwind
export function Icono({ name, size = 20, className = "", ...props }) {
  const iconEntry = icons[name];
  if (!iconEntry) return null;
  const IconComponent = iconEntry.component;

  return (
    <span
      title={iconEntry.description}
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <IconComponent style={{ width: size, height: size }} {...props} />
    </span>
  );
}

// Lista para select
export const CTIconList = Object.entries(icons).map(([key, data]) => ({
  value: key,
  label: data.caption,
  description: data.description,
  icon: <Icono name={key} size={5} className="text-gray-900 dark:text-gray-100" />,
}));

export function getIconByIndex(index) {
  const entries = Object.entries(icons);
  if (index < 0 || index >= entries.length) return null;
  const [name, iconData] = entries[index];
  return { name, ...iconData };
}

export default Icono;


/*

const iconData = getIconByIndex(5);
if (iconData) {
  <Icono name={iconData.name} size={30} />
}

*/